import React, { ReactElement, useEffect } from 'react';
import { InsertRightIcon } from '@milanote/roma-icons';
import useSheet from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import MobileInsertMenuSheet from './MobileInsertMenuSheet';
import ToolbarTool from '../../../ToolbarTool';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import BoardLinkSheet from '../../../../../../components/tiptapEditor/extensions/boardLinks/BoardLinkSheet';

type MobileInsertMenuToolProps = {
    name: string;
    editorKey?: string;
    element?: ImMNElement;
};

const MobileInsertMenuTool = ({ name, editorKey, element }: MobileInsertMenuToolProps): ReactElement | null => {
    const insertMenuSheetProps = useSheet(SheetId.InsertMenuTool);
    const boardLinkSheetProps = useSheet(SheetId.InsertBoardLinkTool);

    const { isOpen, openSheet, closeSheet } = insertMenuSheetProps;

    const openBoardLinkSheet = () => {
        boardLinkSheetProps.openSheet();
    };

    useEffect(() => {
        if (!isOpen || editorKey) return;

        closeSheet();
    }, [isOpen, editorKey, closeSheet]);

    return (
        <>
            <ToolbarTool name={name} isOpen={isOpen} onClick={() => openSheet()}>
                <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
            </ToolbarTool>
            <MobileInsertMenuSheet
                sheetProps={insertMenuSheetProps}
                onLinkBoard={openBoardLinkSheet}
                element={element}
            />

            <BoardLinkSheet sheetProps={boardLinkSheetProps} />
        </>
    );
};

export default MobileInsertMenuTool;
